var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconDreamland(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 15,
    viewBox: "0 0 23 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.72505 11.6239C2.14012 10.1864 4.18735 9.65678 5.13786 9.65678C4.33359 9.20282 2.47647 8.0528 1.48215 7.08437C0.239257 5.87384 1.4819 3.90688 4.26054 3.60408C5.49881 3.46914 7.62385 6.40345 7.91631 5.19291C8.20877 3.98238 8.8618 1.51789 10.6947 1.18316C14.4234 0.502193 15.2278 1.7885 14.8623 3.90685C14.6141 5.34531 13.9116 6.3278 15.9588 5.94951C18.006 5.57122 19.103 3.90672 20.5653 5.19291C22.0276 6.47911 22.8818 10.7342 20.5653 11.1699C18.1523 11.6239 18.2254 8.90019 15.9588 9.65678C13.6922 10.4134 17.7867 11.1699 15.2278 13.2884C13.8708 14.4119 13.0344 14.045 10.6947 13.2884C8.355 12.5318 8.13565 12.3805 7.33138 13.2884C6.52712 14.1963 3.30997 13.0614 2.72505 11.6239Z",
    fill: "#F5CA5C",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDreamland);
export default __webpack_public_path__ + "static/media/icon-dreamland.0310805e4f770b0c11e75b2c754ded29.svg";
export { ForwardRef as ReactComponent };